<script>
export default {
  name: 'LinkedUrl',
  methods: {
    /**
      do the check for their a2e assessment
    */
    hasA2EAssessment (assessmentConfigData) {
      const a2eAssessment = assessmentConfigData && 'is_a2e_assessment' in assessmentConfigData.config
      const isNotV1 = assessmentConfigData && 'is_mvp' in assessmentConfigData.config && assessmentConfigData.config.is_mvp === false
      if (a2eAssessment && isNotV1) {
        return true
      }
      return false
    },
    /**
        has Launcher-based assessment, construct link to Launcher
    */
    hasLauncher (assessmentConfigData) {
      const launcherAssessment = assessmentConfigData && 'launcher' in assessmentConfigData.config
      if (launcherAssessment && assessmentConfigData.config.launcher.enabled === true) {
        return true
      }
      return false
    },

    linkedUrl (item, server) {
      if (item.token) {
        const assessment = item.assessments[0]
        const assessmentConfigData = this.$store.getters['assessmentConfigs/assessmentConfigs'][assessment.assessment_config_id]

        // construct A2E link (if exists)
        if (this.hasA2EAssessment(assessmentConfigData)) {
          return `${server.a2e}/admin?token=${item.token}`
        }
        // construct Launcher link (if exists)
        if (this.hasLauncher(assessmentConfigData)) {
          return `${server.launcher}/?token=${item.token}`
        } else {
          // it's just a legacy tech check for them
          return `${server.tech_check}/?token=${item.token}`
        }
      } else {
        console.error('No login token for this account, cannot display assessment config data')
      }
    }
  }
}
</script>
